import canPlayStream from './canPlayStream';

export default function canPlayContent({ status, streams = [] } = {}, userAuth, optimisitic = true) {
    return status != 'upcoming' && streams.some(stream => canPlayStream(stream, userAuth, optimisitic));
}



// WEBPACK FOOTER //
// ./app/lib/auth/canPlayContent.js